import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetDressCodePicturesAction } from '../../actions/dress-code-pictures/get-dress-code-pictures-action';
import { GetDressCodePicturesSuccessAction } from '../../actions/dress-code-pictures/get-dress-code-pictures-success-action';
import { GetDressCodePicturesErrorAction } from '../../actions/dress-code-pictures/get-dress-code-pictures-error-action';

@Injectable()
export class GetDressCodePicturesEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public GetDressCodePicturesActions = createEffect(() => this.actions
    .pipe(
      ofType(GetDressCodePicturesAction.type),
      mergeMap(action => {
        const getDressCodePicturesAction = <GetDressCodePicturesAction>action;
        return this.api.getDressCodePictures(getDressCodePicturesAction.bijbEvent).then(dressCodePictures => {
          return new GetDressCodePicturesSuccessAction(dressCodePictures);
        }, error => {
          return new GetDressCodePicturesErrorAction({ ...error, fatal: true });
        });
      })
    ));
}
